var map = {
	"./0.svg": 19,
	"./1.svg": 20,
	"./2.svg": 21,
	"./3.svg": 22,
	"./4.svg": 23,
	"./5.svg": 24,
	"./6.svg": 25,
	"./7.svg": 26,
	"./8.svg": 27,
	"./9.svg": 28,
	"./a.svg": 29,
	"./b.svg": 30,
	"./c.svg": 31,
	"./d.svg": 32,
	"./e.svg": 33,
	"./f.svg": 34,
	"./g.svg": 35,
	"./h.svg": 36,
	"./i.svg": 37,
	"./j.svg": 38,
	"./k.svg": 39,
	"./l.svg": 40,
	"./m.svg": 41,
	"./n.svg": 42,
	"./o.svg": 43,
	"./p.svg": 44,
	"./q.svg": 45,
	"./r.svg": 46,
	"./s.svg": 47,
	"./t.svg": 48,
	"./u.svg": 49,
	"./v.svg": 50,
	"./w.svg": 51,
	"./x.svg": 52,
	"./y.svg": 53,
	"./z.svg": 54
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;